/* 展示風景の拡大表示（ライトボックス）。
   グリッド自体はHTML/CSSだけで完成しているので、このJSが動かなくても表示は崩れない。 */
(function () {
  /* 画面の文言：layout/theme.liquid → snippets/i18n-js が window.__i18n.exhv に言語ごとの文言を入れる。無ければ日本語の既定（2026-10-25） */
  var I18N = (window.__i18n && window.__i18n.exhv) || {};
  function T(k, d) { var v = I18N[k]; return (v == null || v === '') ? d : v; }
  var grid = document.querySelector('[data-exhv]');
  if (!grid) return;

  var items = Array.prototype.slice.call(grid.querySelectorAll('[data-exhv-open]'));
  if (!items.length) return;

  var box, imgEl, capEl, prevBtn, nextBtn, index = 0, opener = null;

  function build() {
    box = document.createElement('div');
    box.className = 'exhv__box';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', T('installation_views', '展示風景'));
    box.innerHTML =
      '<button class="exhv__close" type="button" aria-label="' + T('close', '閉じる') + '">&times;</button>' +
      '<button class="exhv__nav exhv__nav--prev" type="button" aria-label="' + T('prev_photo', '前の写真') + '">&#8249;</button>' +
      '<button class="exhv__nav exhv__nav--next" type="button" aria-label="' + T('next_photo', '次の写真') + '">&#8250;</button>' +
      '<figure class="exhv__stage"><img alt=""><figcaption></figcaption></figure>';
    document.body.appendChild(box);
    imgEl = box.querySelector('img');
    capEl = box.querySelector('figcaption');
    prevBtn = box.querySelector('.exhv__nav--prev');
    nextBtn = box.querySelector('.exhv__nav--next');

    box.addEventListener('click', function (e) {
      if (e.target === box || e.target.classList.contains('exhv__close') || e.target.classList.contains('exhv__stage')) close();
    });
    prevBtn.addEventListener('click', function () { go(index - 1); });
    nextBtn.addEventListener('click', function () { go(index + 1); });

    var x0 = null;
    box.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    box.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 50) go(index + (dx < 0 ? 1 : -1));
      x0 = null;
    }, { passive: true });
  }

  function go(i) {
    index = (i + items.length) % items.length;
    var b = items[index];
    imgEl.src = b.getAttribute('data-exhv-open');
    var inner = b.querySelector('img');
    imgEl.alt = inner ? inner.alt : '';
    capEl.textContent = items.length > 1 ? (index + 1) + ' / ' + items.length : '';
    var single = items.length < 2;
    prevBtn.hidden = single;
    nextBtn.hidden = single;
  }

  function open(i, from) {
    if (!box) build();
    opener = from || null;
    go(i);
    document.documentElement.classList.add('exhv-open');
    box.classList.add('is-open');
    if (window.lenis && window.lenis.stop) window.lenis.stop();
    box.querySelector('.exhv__close').focus();
  }

  function close() {
    if (!box) return;
    box.classList.remove('is-open');
    document.documentElement.classList.remove('exhv-open');
    if (window.lenis && window.lenis.start) window.lenis.start();
    if (opener) opener.focus();
  }

  items.forEach(function (b, i) {
    b.addEventListener('click', function () { open(i, b); });
  });

  document.addEventListener('keydown', function (e) {
    if (!box || !box.classList.contains('is-open')) return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowLeft') go(index - 1);
    else if (e.key === 'ArrowRight') go(index + 1);
  });
})();
